import { RouteObject } from 'react-router-dom';

export interface RouteItem {
    label?: string,
    listed?: boolean,
    accessRestriction?: AccessRestriction,
    route: RouteObject
};

export interface NavigationProviderProps {
    children?: React.ReactNode;
    routes: RouteObject[];
}

export type RouteInterceptor<T> = (routerConfig: RouteItem[], session?: T) => RouteItem[]

export type RoutesMaker = <T>(
    routerConfig: RouteItem[],
    interceptor: RouteInterceptor<T>,
    session?: T
) => RouteObject[]

export enum AccessRestriction {
    PUBLIC = "PUBLIC",
    PRIVATE = "PRIVATE"
}
